import { CurrentPlatformType } from './platform.types';

export const currentPlatform: CurrentPlatformType = CurrentPlatformType.WEB;
